import { render } from "./pieEcharts.vue?vue&type=template&id=55b1c284&scoped=true"
import script from "./pieEcharts.vue?vue&type=script&lang=js"
export * from "./pieEcharts.vue?vue&type=script&lang=js"

import "./pieEcharts.vue?vue&type=style&index=0&id=55b1c284&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b1c284"]])

export default __exports__